<template>
  <div
    v-for="(allocation, index) in part.allocationsAttributes"
    :key="`resource-${index}`"
    :class="[
      $style.resource,
      {
        [$style.fullWidth]: fullWidth || isSmallScreen
      }
    ]"
  >
    <DisabledResource
      v-if="hasDeletedService && !hasSingleResource"
      :allocation="allocation"
      v-test="'part-resource-disabled'"
    />
    <ResourceSelect
      v-else-if="!hasSingleResource"
      :allocation="allocation"
      :partIndex="partIndex"
      :allocationIndex="index"
      :disabled="hasDeletedService"
      :allAllocations="part.allocationsAttributes"
      :hideEmployeeLabel="hideEmployeeLabel"
    />
  </div>
</template>

<script
  lang="ts"
  setup
>
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { isSmallScreen } from '@/modules/calendar/appointment/helpers.ts';
import { useCreateAppointmentStore } from '@/stores/calendar-create-appointment';
import { useResourcesStore } from '@/stores/resources';
import type { AppointmentPartAttributes } from '@/types';
import DisabledResource from './DisabledResource.vue';
import ResourceSelect from './ResourceSelect.vue';

type Props = {
  part: AppointmentPartAttributes;
  partIndex: number;
  hideEmployeeLabel?: boolean;
  fullWidth?: boolean;
};

const props = withDefaults(defineProps<Props>(), {
  hideEmployeeLabel: false,
  fullWidth: false,
});

const { services } = storeToRefs(useCreateAppointmentStore());
const { hasSingleResource } = storeToRefs(useResourcesStore());

const hasDeletedService = computed(
  () =>
    !!services.value.find((service) => service.id === props.part.serviceId)
      ?.deleted,
);
</script>

<style
  lang="scss"
  module
>
.resource {
  width: 30%;

  &.fullWidth {
    width: 100%;
  }

  &:empty {
    display: none;
  }
}
</style>
